import { useQuery } from '@tanstack/react-query'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { transformContactsV3Response } from 'pages/Contacts/utils/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContacts, getContactsV3 } from 'services/ContactService'
import { Contact, ContactsRequest } from 'types/contacts'
import type { WithPaginationPaging } from 'types/pagination'
import { API_PAGINATION_LIMIT, withPaginationPaging } from 'utils/pagination'

export const useContactsQuery = ({
  size = API_PAGINATION_LIMIT,
  page = 0,
  searchQuery = '',
  totalCountLimit,
}: ContactsRequest) => {
  const { enableV3Contacts } = useFeatureFlags()

  return useQuery({
    queryKey: enableV3Contacts
      ? reactQueryKeys.contactsV3({
          ...(size && { size }),
          ...(page && { page }),
          ...(searchQuery && { searchQuery }),
        })
      : reactQueryKeys.contacts({
          ...(size && { size }),
          ...(page && { page }),
          ...(searchQuery && { searchQuery }),
          ...(totalCountLimit && { totalCountLimit }),
        }),
    queryFn: async (): Promise<WithPaginationPaging<Contact[]>> =>
      enableV3Contacts
        ? transformContactsV3Response(await getContactsV3({ size, page, searchQuery }))
        : withPaginationPaging(await getContacts({ size, page, searchQuery, totalCountLimit })),
  })
}
